const magenta = {
  100: '#E30177'
};

export { magenta };
